const useAuthGuard = () => {
    const KEY = 'oidcProtector';

    const isAuthenticating = () => {
        const value = localStorage.getItem(KEY);
        if (value) {
            return Date.now() - parseInt(value) < 5000;
        }
        return false;
    };
    const startAuth = () => {
        localStorage.setItem(KEY, Date.now().toString());
    };

    return { isAuthenticating, startAuth };
};

export default useAuthGuard;
